export default {
    init() {
            // JavaScript to be fired on the home page
            $('.anchor-link').click(function() {
                $('html, body').animate({
                    scrollTop: $('.categorieen').offset().top
                }, 500); 
                return false;
            });

            $('#open_video').click(function() {
                $('<iframe id="video_iframe" frameborder="0" height="100%" width="100%" src="https://www.youtube.com/embed/axx0a98VJTo?rel=0&controls=0&showinfo=0&modestbranding=0&autoplay=1"></iframe>').appendTo('#video');
                $('#video').fadeIn();
            });

            $('#close_video').click(function() {
                $('#video').fadeOut();
                $('#video_iframe').remove();
            });

        },
        finalize() {
            // JavaScript to be fired on the home page, after the init JS
        },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js